import { validateRmData } from '../validations/validateRmData'

export function createValidate(lockedNames: string[]) {
  return (
    values: uui.domain.ui.forms.RmVehicleFormValues,
  ): uui.domain.ui.forms.RmVehicleFormValidationValues => ({
    rm: validateRmData(values.rm, lockedNames, values),
  })
}
